var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentAdvice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 2.66667V0H0.333984V12H13.6673V2.66667H7.00065ZM3.00065 10.6667H1.66732V9.33333H3.00065V10.6667ZM3.00065 8H1.66732V6.66667H3.00065V8ZM3.00065 5.33333H1.66732V4H3.00065V5.33333ZM3.00065 2.66667H1.66732V1.33333H3.00065V2.66667ZM5.66732 10.6667H4.33398V9.33333H5.66732V10.6667ZM5.66732 8H4.33398V6.66667H5.66732V8ZM5.66732 5.33333H4.33398V4H5.66732V5.33333ZM5.66732 2.66667H4.33398V1.33333H5.66732V2.66667ZM12.334 10.6667H7.00065V9.33333H8.33398V8H7.00065V6.66667H8.33398V5.33333H7.00065V4H12.334V10.6667ZM11.0007 5.33333H9.66732V6.66667H11.0007V5.33333ZM11.0007 8H9.66732V9.33333H11.0007V8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAdvice);
export default __webpack_public_path__ + "static/media/payment-advice.c428e614f1fe6274f0529b5bfeae440c.svg";
export { ForwardRef as ReactComponent };